var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99935 0.666687C13.6017 0.666687 17.3327 4.39765 17.3327 9.00002C17.3327 13.6024 13.6017 17.3334 8.99935 17.3334C4.39698 17.3334 0.666016 13.6024 0.666016 9.00002C0.666016 4.39765 4.39698 0.666687 8.99935 0.666687ZM8.99935 2.33335C5.31745 2.33335 2.33268 5.31812 2.33268 9.00002C2.33268 12.6819 5.31745 15.6667 8.99935 15.6667C12.6812 15.6667 15.666 12.6819 15.666 9.00002C15.666 5.31812 12.6812 2.33335 8.99935 2.33335ZM8.99935 7.33335C9.45959 7.33335 9.83268 7.70645 9.83268 8.16669V13.1667C9.83268 13.6269 9.45959 14 8.99935 14C8.53911 14 8.16602 13.6269 8.16602 13.1667V8.16669C8.16602 7.70645 8.53911 7.33335 8.99935 7.33335ZM8.99935 4.00002C9.45959 4.00002 9.83268 4.37312 9.83268 4.83335C9.83268 5.29359 9.45959 5.66669 8.99935 5.66669C8.53911 5.66669 8.16602 5.29359 8.16602 4.83335C8.16602 4.37312 8.53911 4.00002 8.99935 4.00002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/IconInfo.47e8809c.svg";
export { ForwardRef as ReactComponent };